module.exports = new __parcel__URL__("XMRLogo.26608d9e.svg").toString();